import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';

import { backendFetch } from '../../backend/backend';
import Subtitle from '../ui/Subtitle';
import BaseLeagueTable from '../tables/BaseLeagueTable';
import ScoringStructureTable from '../tables/ScoringStructureTable';

const FormTablePage = () => {
	const [formTable,setFormTable]=useState([]);
	const [scoringStructure,setScoringStructure]=useState({structure:[],maxScoresToCount:0});
	const [fetched,setFetched]=useState(false);

	useEffect(()=>{
		async function fetchData() {
			const form=await backendFetch('form');
			setFormTable(form);
			const scoring=await backendFetch('scoring?season=active');
			setScoringStructure(scoring);
			setFetched(true);
		}
		fetchData();
	},[]);

	return(
		<Stack direction={{xs:"column",md:"row"}} justifyContent="space-between">
			<Stack spacing="0" width={{xs:"100%",md:"60%"}}>
      	<Subtitle text="Form Table"/>
				{ fetched && <BaseLeagueTable leagueTable={formTable} variant="form"/>}
			</Stack>
			{ fetched &&
				<Stack width="50%">
					<ScoringStructureTable scoringStructure={scoringStructure} />
				</Stack>
			}		
		</Stack>
	);


}

export default FormTablePage;
